import { SearchOutlined } from '@ant-design/icons';
import { App, Input, Spin } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileEmpty } from '@/components/mobile/MobileEmpty';
import { MobileProjectCard } from '@/components/mobile/MobileProjectCard';
import { PROJECT_STATUS } from '@/constants/project';
import { ROUTES } from '@/constants/routes';
import { ApiError } from '@/services/api/client';
import * as projectsApi from '@/services/api/projects';
import type { ProjectListItem } from '@/types/project';

export function EmployeeProjectsPage() {
  const { message } = App.useApp();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<ProjectListItem[]>([]);
  const [keyword, setKeyword] = useState('');
  const [search, setSearch] = useState('');

  const loadProjects = useCallback(async () => {
    setLoading(true);
    try {
      const result = await projectsApi.fetchProjects({
        page: 1,
        pageSize: 100,
        status: PROJECT_STATUS.ACTIVE,
        keyword: search.trim() || undefined,
      });
      setItems(result.items);
    } catch (error) {
      const text = error instanceof ApiError ? error.message : '加载项目列表失败';
      message.error(text);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [message, search]);

  useEffect(() => {
    void loadProjects();
  }, [loadProjects]);

  return (
    <div className="mobile-workbench">
      <div className="mobile-filter-panel">
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder="搜索项目名称 / 编号"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onPressEnter={() => setSearch(keyword)}
        />
        <button type="button" className="mobile-filter-btn" onClick={() => setSearch(keyword)}>
          搜索
        </button>
      </div>

      <section className="mobile-section">
        <div className="mobile-section__header">
          <span className="mobile-section__title">我的项目</span>
          <span className="mobile-section__meta">共 {items.length} 个</span>
        </div>

        {loading ? (
          <div className="mobile-card" style={{ textAlign: 'center', padding: 24 }}>
            <Spin />
          </div>
        ) : items.length === 0 ? (
          <MobileEmpty message="暂无参与中的项目" />
        ) : (
          items.map((project) => (
            <MobileProjectCard
              key={project.id}
              project={project}
              onClick={() => navigate(ROUTES.mobile.employee.projectDetail(project.id))}
            />
          ))
        )}
      </section>
    </div>
  );
}
